import Logout from '~/components/Logout'

export default function LogoutPage () {
  return <Logout />
}
